import { Link } from "react-router-dom";
import { CONTACT, BRAND } from "../data/experiences";

export const Footer = () => (
  <footer className="bg-obsidian text-ivory" data-testid="main-footer">
    <div className="editorial-container py-16 sm:py-20">
      <div className="flex flex-col md:flex-row md:justify-between gap-10">
        <div>
          <Link to="/" data-testid="footer-brand-link" className="inline-block"><img src={BRAND.wordmarkDark} alt="UNZIP DELHI" width="860" height="604" className="w-36 h-auto object-contain mb-6" data-testid="footer-wordmark" /></Link>
          <p className="font-serif text-2xl text-ivory" data-testid="footer-tagline">Heritage. Culture. Stories.</p>
          <p className="mt-4 text-sm text-ivory/70" data-testid="footer-cities">Delhi · Agra · Jaipur</p>
        </div>
        <div className="md:pt-3">
          <nav aria-label="Footer" className="flex flex-wrap gap-x-7 gap-y-4 text-sm" data-testid="footer-navigation">
            <a href={CONTACT.instagramUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="hover:text-gold transition-colors">Instagram</a>
            <a href={CONTACT.youtubeUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-youtube" className="hover:text-gold transition-colors">YouTube</a>
            <Link to="/contact" data-testid="footer-link-contact" className="hover:text-gold transition-colors">Contact</Link>
            <Link to="/about" data-testid="footer-link-about" className="hover:text-gold transition-colors">About</Link>
            <Link to="/experiences" data-testid="footer-link-experiences" className="hover:text-gold transition-colors">Experiences</Link>
          </nav>
          <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="block mt-8 text-sm text-ivory/70 hover:text-gold transition-colors">{CONTACT.email}</a>
          <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="block mt-4 text-sm text-ivory/70 hover:text-gold transition-colors">{CONTACT.phone} (WhatsApp)</a>
        </div>
      </div>
      <div className="mt-12 pt-7 pb-12 sm:pb-0 border-t border-ivory/20 flex flex-col sm:flex-row justify-between gap-5 text-xs text-ivory/60">
        <p data-testid="footer-copyright">© {new Date().getFullYear()} Unzip Delhi. All rights reserved.</p>
        <div className="flex gap-6">
          <Link data-testid="footer-link-privacy" to="/privacy" className="hover:text-gold transition-colors">Privacy</Link>
          <Link data-testid="footer-link-terms" to="/terms" className="hover:text-gold transition-colors">Terms</Link>
        </div>
      </div>
    </div>
  </footer>
);
